import { TailoredSupplyTable } from './components/TailoredSupplyTable/TailoredSupplyTable';

export function TailoredSupplyListPage() {
  return (
    <main className="page-gutter min-w-0 py-6">
      <TailoredSupplyTable />
    </main>
  );
}
